import _ from 'lodash';
import React from 'react';
import Loading from '../components/common/LoadingGrommet';
import KeycloakJS from 'keycloak-js';
import PropTypes from 'prop-types';
import Authenticated from './Authenticated';
import ErrorBoundary from '../components/common/ErrorBoundary';
import AppPublicContainer from '../components/AppPublicContainer';
import { Spin } from 'antd';

import { connect } from 'react-redux';
import {
  loginStart,
  loginSuccess,
  loginFailure,
  checkPublicRoute,
} from '../actions/keycloak';

export const Keycloak = React.createContext();

/**
 * Authenticator
 * Keycloak Provider, Recibe la config leida de los envs y setea
 */
class Authenticator extends React.Component {
  state = { keycloak: null, authenticated: false, initializing: true };

  componentDidMount() {
    this.startup();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isLoggingIn && this.props.isLoggingIn) {
      console.log("Detected login attempt, initiating Keycloak login");
      this.login();
    }
  }

  startup = async () => {
    try {
      this.props.loginFailure();
      console.log("<Authenticator> /startup")
      const { keycloakConfig } = this.props;
      const keycloak = KeycloakJS(keycloakConfig);
      const authenticated = await keycloak.init({
        onLoad: 'check-sso',
        checkLoginIframe: false,
        promiseType: 'native',
        enableLogging: true,
        // silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
      });
      console.log("<Authenticator> /startup authenticated:", authenticated)
      if(authenticated) {
        console.log("Login Sucessful")
        this.props.loginSuccess();
      }else{
        console.log("loginFailure")
        this.props.loginFailure();
      }

      this.setState({ 
        keycloak, 
        authenticated,
        initializing: false
      });
    } catch (e) {
      console.error("Keycloak initialization error:", e);
      // throw new Error('No pudimos establecer conexion con Keycloak', e);
      // Mark initialization as complete even though it failed
      this.setState({ 
        initializing: false,
        authenticated: false 
      });

      // Dispatch login failure action
      this.props.loginFailure(e.message || "Error connecting to Keycloak");
    }
  };

  login = async () => {
    try {
      const { keycloakConfig } = this.props;
      const keycloak = new KeycloakJS(keycloakConfig);
      keycloak.init({
        checkLoginIframe: false,
        enableLogging: true,
      });
      this.props.loginStart();
      keycloak.login();
    } catch (error) {
      console.error("Login error:", error);
      this.props.loginFailure(error.message || "Error during login");
    }
  }


  render() {
    const { keycloak, authenticated, initializing } = this.state;
    
    if (initializing) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh' 
        }}>
          <Spin size="large" tip="Verificando autenticación..." />
        </div>
      );
    }

    if (!authenticated) {
      return <AppPublicContainer />;
    } else {
      return (
        <ErrorBoundary>
          <Loading isLoading={_.isEmpty(keycloak)}>
            <Authenticated isAuthenticated={authenticated}>
              <Keycloak.Provider value={{ keycloak, authenticated }}>
                {this.props.children}
              </Keycloak.Provider>
            </Authenticated>
          </Loading>
        </ErrorBoundary>
      );
    }
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isLoggingIn: state.keycloak ? state.keycloak.isLoggingIn : false,
    isLoggedIn: state.keycloak ? state.keycloak.isLoggedIn : false,
  };
}

const mapDispatchToProps = {
  loginStart,
  loginSuccess,
  loginFailure,
  checkPublicRoute,
};

Authenticator.propTypes = {
  keycloakConfig: PropTypes.shape({
    realm: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    'ssl-required': PropTypes.string.isRequired,
    resource: PropTypes.string.isRequired,
    'public-client': PropTypes.bool.isRequired,
    'confidential-port': PropTypes.number.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Authenticator);
